export const PromotionalImage = ({ promotionTag, className, }) => {
    if (!promotionTag)
        return <></>;
    return <img alt={promotionTag.alt || ""} src={promotionTag.url} className={className || "w-15"}/>;
};
